import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseRolesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseRoles/GetRoleById/${props.roleId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseRoles/CreateFranchiseRole`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseRoles/EditFranchiseRole`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'FranchiseRoles/GetRoles', method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseRoles/EditFranchiseRole/${props.roleId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const listPermissionsRecords = useCallback(async () => {
        await execute({ scope: 'listperms', url: 'FranchiseRoles/GetPermissions', method: 'GET', secure: true });
    }, [execute]);  

    const listAllPermissions = useCallback(async () => {
        await execute({ scope: 'listperms', url: 'FranchiseRoles/GetPermissions', method: 'GET', secure: true });
    }, [execute]);  
    
    const createRolePermission = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseRoles/AssignPermissionToRole`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const deleteRolePermission = useCallback(async (props) => {
        await execute({ scope: 'post_delete', url: `FranchiseRoles/DeletePermissionFromRole?roleId=${props.roleId}&permissionId=${props.permissionId}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, listPermissionsRecords, listAllPermissions, createRolePermission, deleteRolePermission, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseRolesStore = () => React.useContext(Context);
